export const GET_POINTS = Symbol('GET_POINTS');
export const GET_POINTS_REQUEST = Symbol('GET_POINTS_REQUEST');
export const GET_POINTS_SUCCESS = Symbol('GET_POINTS_SUCCESS');
export const GET_POINTS_ERROR = Symbol('GET_POINTS_ERROR');

